import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class ActionPromtService {
  constructor(public dialog: MatDialog, private authService: AuthService) {}

  async openModal(
    permission: string,
    success: Function = null,
    error: Function = null,
    enteredPinHasOtherCheckedPermission?: string
  ) {
    if (!this.authService.isValidPermission(permission)) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;
      dialogConfig.data = {
        permission: permission,
        enteredPinHasOtherCheckedPermission: enteredPinHasOtherCheckedPermission
      };
      dialogConfig.maxWidth = '100vw';
      dialogConfig.maxHeight = '90vh';

      const { ActionPromptDialogComponent } = await import(
        /* webpackPrefetch: true */ '../dialog/action-prompt-dialog/action-prompt-dialog.component'
      );

      const dialogRef = this.dialog.open(
        ActionPromptDialogComponent,
        dialogConfig
      );

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          if (success) {
            success(result);
          }
        } else {
          if (error) {
            error(error);
          }
        }
      });
    } else {
      success({
        data: localStorage.getItem('token'),
        status: 1,
        message: 'AUTHORIZED',
      });
    }
  }
}
